import { createAction, handleActions } from "redux-actions";

const actionScope = "PARTNER_SESSION_";

export const partnerSessionRequestFailed = createAction(actionScope + "REQUEST_FAIL");

export const loadPartnerODMRequest = createAction(actionScope + "LOAD_PARTNER_ODM_REQUEST");
export const loadPartnerODMSuccess = createAction(actionScope + "LOAD_PARTNER_ODM_SUCCESS");

export const setPartnerODMRequest = createAction(actionScope + "SET_PARTNER_ODM_REQUEST");
export const setPartnerODMSuccess = createAction(actionScope + "SET_PARTNER_ODM_SUCCESS");

export const updatePartnerRequest = createAction(actionScope + "UPDATE_PARTNER_REQUEST");
export const updatePartnerSuccess = createAction(actionScope + "UPDATE_PARTNER_SUCCESS");

export const deletePartnerRequest = createAction(actionScope + "DELETE_PARTNER_REQUEST");
export const deletePartnerSuccess = createAction(actionScope + "DELETE_PARTNER_SUCCESS");

export const loadPartnerAssessmentsRequest = createAction(
  actionScope + "LOAD_PARTNER_ASSESSMENTS_REQUEST"
);
export const loadPartnerAssessmentsSuccess = createAction(
  actionScope + "LOAD_PARTNER_ASSESSMENTS_SUCCESS"
);

export const setPartnerAssessmentsRequest = createAction(
  actionScope + "SET_PARTNER_ASSESSMENTS_REQUEST"
);
export const setPartnerAssessmentsSuccess = createAction(
  actionScope + "SET_PARTNER_ASSESSMENTS_SUCCESS"
);

export const reflectUpdatedAssessmentODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_ASSESSMENT_ODM_REQUEST"
);
export const reflectUpdatedAssessmentODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_ASSESSMENT_ODM_SUCCESS"
);

export const loadPartnerPatientsRequest = createAction(
  actionScope + "LOAD_PARTNER_PATIENTS_REQUEST"
);
export const loadPartnerPatientsSuccess = createAction(
  actionScope + "LOAD_PARTNER_PATIENTS_SUCCESS"
);

export const setPartnerPatientsRequest = createAction(actionScope + "SET_PARTNER_PATIENTS_REQUEST");
export const setPartnerPatientsSuccess = createAction(actionScope + "SET_PARTNER_PATIENTS_SUCCESS");

export const reflectUpdatedPatientODMRequest = createAction(
  actionScope + "REFLECT_UPDATED_PATIENT_ODM_REQUEST"
);
export const reflectUpdatedPatientODMSuccess = createAction(
  actionScope + "REFLECT_UPDATED_PATIENT_ODM_SUCCESS"
);

export const loadPartnerInvitesRequest = createAction(actionScope + "LOAD_PARTNER_INVITES_REQUEST");
export const loadPartnerInvitesSuccess = createAction(actionScope + "LOAD_PARTNER_INVITES_SUCCESS");

export const setPartnerInvitesRequest = createAction(actionScope + "SET_PARTNER_INVITES_REQUEST");
export const setPartnerInvitesSuccess = createAction(actionScope + "SET_PARTNER_INVITES_SUCCESS");

// selectors
export const partnerODMSelector = state => state.partnerSession.partnerODM;
export const partnerAssessmentsSelector = state => state.partnerSession.partnerAssessments;
export const partnerPatientsSelector = state => state.partnerSession.partnerPatients;
export const partnerInvitesSelector = state => state.partnerSession.partnerInvites;

// initial state
const initialState = {
  //these members use the omnDataModel defined by the JSON in this project
  partnerODM: null,
  partnerAssessments: null,
  partnerPatients: null,
  partnerInvites: null,
};

// reducers
export default handleActions(
  {
    [partnerSessionRequestFailed]: state => state,

    [loadPartnerODMRequest]: state => state,
    [loadPartnerODMSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setPartnerODMRequest]: state => state,
    [setPartnerODMSuccess]: (state, { payload }) => ({
      ...state,
      partnerODM: payload,
    }),

    [updatePartnerRequest]: state => state,
    [updatePartnerSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [deletePartnerRequest]: state => state,
    [deletePartnerSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [loadPartnerAssessmentsRequest]: state => state,
    [loadPartnerAssessmentsSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setPartnerAssessmentsRequest]: state => state,
    [setPartnerAssessmentsSuccess]: (state, { payload }) => ({
      ...state,
      partnerAssessments: payload,
    }),

    [reflectUpdatedAssessmentODMRequest]: state => state,
    [reflectUpdatedAssessmentODMSuccess]: (state, { payload }) => ({
      ...state,
      partnerAssessments: payload,
    }),

    [loadPartnerPatientsRequest]: state => state,
    [loadPartnerPatientsSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setPartnerPatientsRequest]: state => state,
    [setPartnerPatientsSuccess]: (state, { payload }) => ({
      ...state,
      partnerPatients: payload,
    }),

    [reflectUpdatedPatientODMRequest]: state => state,
    [reflectUpdatedPatientODMSuccess]: (state, { payload }) => ({
      ...state,
      partnerPatients: payload,
    }),

    [loadPartnerInvitesRequest]: state => state,
    [loadPartnerInvitesSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setPartnerInvitesRequest]: state => state,
    [setPartnerInvitesSuccess]: (state, { payload }) => ({
      ...state,
      partnerInvites: payload,
    }),
  },
  initialState
);
